export function isValidCpr(cpr) {
  return typeof cpr === 'string' && cpr.length === 10 && /^\d{10}$/.test(cpr);
}

export function isValidCvr(cvr) {
  return typeof cvr === 'string' && cvr.length === 8 && /^\d{8}$/.test(cvr);
}
